import { render, staticRenderFns } from "./CertificateStatus.vue?vue&type=template&id=5ca7b077&"
import script from "./CertificateStatus.vue?vue&type=script&lang=js&"
export * from "./CertificateStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports